import { useDesktopShell } from "@/lib/useDesktopShell";

// Brand strip rendered behind the OS-native window controls. Visible
// only inside the Electron shell — `titleBarStyle: "hidden"` +
// `titleBarOverlay` in the main process paints native minimize /
// maximize / close buttons in the top-right corner; this component
// fills the LEFT side of that 32px strip with the brand label and
// keeps the area draggable via `-webkit-app-region: drag`.
export function DesktopTitleBar() {
    const { isDesktop } = useDesktopShell();
    if (!isDesktop) return null;

    return (
        <div
            className="mail-appbar flex h-8 select-none items-center px-3 text-xs font-semibold tracking-wide"
            style={{ WebkitAppRegion: "drag" }}
        >
            <span aria-hidden="true" className="mr-2">📬</span>
            <span>Athavita Mail</span>
        </div>
    );
}
